// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"makeCartTemplateItem_checkbox__Hy10d","bottomTablet":"makeCartTemplateItem_bottomTablet__GqI5B"};